import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import CustomerItem, {
  makeEmptyCustomerItem,
} from '../../../models/helperTypes/CustomerItem';

export type CustomerState = {
  settingCustomerInfo: boolean;
  currentCustomer: CustomerItem;
};

const initialState: CustomerState = {
  settingCustomerInfo: false,
  currentCustomer: makeEmptyCustomerItem(),
};

const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setCurrentCustomer: (state, action: PayloadAction<CustomerItem>): void => {
      state.currentCustomer = action.payload;
    },
  },
});

export const { setCurrentCustomer } = customerSlice.actions;

export default customerSlice.reducer;
